import { useParams } from 'react-router';
import { EditEventMerchantOrder } from './EditEventMerchantOrder';
import { EditEventMerchantOrderProvider } from './EditEventMerchantOrderContext';

export default function EditEventMerchantOrderPage() {
  const { sharedLinkId } = useParams<{ sharedLinkId: string }>();

  if (!sharedLinkId) {
    return <div>Shared Link ID is required</div>;
  }

  return (
    <EditEventMerchantOrderProvider sharedLinkId={sharedLinkId}>
      <EditEventMerchantOrder />
    </EditEventMerchantOrderProvider>
  );
}
